module.exports = __webpack_public_path__ + "static/media/taxi-three-color.efacf5b0.png";